import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import Header from './Header';
import Sidebar from './Sidebar';
import PageWrapper from './PageWrapper';

interface ClientLayoutProps {
  children: React.ReactNode;
}

const ClientLayout: React.FC<ClientLayoutProps> = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="min-h-screen bg-background text-text flex flex-col font-sans antialiased ">
      <Header
        isClientLayout={true}
      />

      <div className="flex flex-1 overflow-hidden">

        {isSidebarOpen && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="fixed inset-0 bg-background bg-opacity-50 z-30 md:hidden"
            onClick={toggleSidebar}
          ></motion.div>
        )}

        <main className="flex-1 overflow-y-auto p-2 md:p-4 lg:p-4">
          <PageWrapper>
            {children}
          </PageWrapper>
        </main>
      </div>
    </div>
  );
};

export default ClientLayout;